import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Icons from '../../../utilities/js/icons';
import './videoModal.css';

const VideoToggle = (props) => {
  const { onClick } = props;
  return(
    <div className="video-toggle">
      <img
        className="video-toggle--thumb"
        src="http://pornoundpiano.de/assets/media/img/video-thumb.jpg"
        alt="video toggle thumbnail"
      />
      <span className="video-toggle--button" onClick={onClick}>
        <Icons.Media.Play />
      </span>
    </div>
  );
}

class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleToggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    const { isOpen } = this.state;
    return (
      <React.Fragment>
        <VideoToggle onClick={this.handleToggle} />
        <Modal isOpen={isOpen} toggle={this.handleToggle} className="video-modal">
          <ModalBody>
          {/*<video width="320" controls autoPlay>
              <source src="http://pornoundpiano.de/assets/media/video/Porno&Piano5.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>*/}
          {/*<iframe
              title="porno&piano_trailer"
              src="https://player.vimeo.com/video/318193583"
              width="320"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>*/}
            <iframe
              title="porno&piano_trailer"
              width="320"
              src="https://www.youtube.com/embed/mV30vRLWAJ8"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default VideoModal;
